export default "__VITE_ASSET__CFW_hYqW__"